import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import HomePage from './pages/HomePage';
import VideoBoothPage from './pages/VideoBoothPage';
import EscapeBoothPage from './pages/EscapeBoothPage';
import ComingSoon from './pages/ComingSoon';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/*<Route path="/" element={<ComingSoon />} />*/}
        <Route path="/slimefluencer" element={<VideoBoothPage />} />
        <Route path="/escape" element={<EscapeBoothPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
